import Vue from "vue";
import VueRouter from "vue-router";
import smartquotes from "smartquotes";
import NProgress from "nprogress";
import store from "./store";

// const Dashboard = () =>
//   import(/* webpackChunkName: "home" */ "../views/Dashboard.vue");
// const Login = () =>
//   import(/* webpackChunkName: "about" */ "../views/AuthEmail.vue");
const Error404 = () =>
  import(/* webpackChunkName: "about" */ "../views/Error404.vue");
  const Success = () =>
  import(/* webpackChunkName: "about" */ "../views/Success.vue");
// const Users = () =>
//   import(/* webpackChunkName: "about" */ "../views/Users.vue");
// const Customers = () =>
//   import(/* webpackChunkName: "about" */ "../views/Customers.vue");
const Landing = () =>
  import(/* webpackChunkName: "about" */ "../views/Landing.vue");
const CustomerCreate = () =>
  import(/* webpackChunkName: "about" */ "../views/CustomerCreate.vue");
// const Vehicles = () =>
//   import(/* webpackChunkName: "about" */ "../views/Vehicles.vue");

const routes = [
  {
    path: "/",
    component: Landing,
    meta: {
      title: "Route Line",
      layout: "blank"
    }
  },
  // {
  //   path: "/auth",
  //   component: Login,
  //   meta: {
  //     title: "Route Line",
  //     layout: "blank"
  //   }
  // },
  // {
  //   path: "/dashboard",
  //   component: Dashboard,
  //   meta: {
  //     title: "Dashboard",
  //     layout: "admin",
  //     auth: true
  //   }
  // },
  // {
  //   path: "/users",
  //   component: Users,
  //   meta: {
  //     title: "Users",
  //     layout: "admin",
  //     auth: true
  //   }
  // },
  // {
  //   path: "/customers",
  //   component: Customers,
  //   meta: {
  //     title: "Customers",
  //     layout: "admin",
  //     auth: true
  //   }
  // },
  // {
  //   path: "/customers/:id",
  //   component: Customers,
  //   meta: {
  //     title: "Customer",
  //     layout: "admin",
  //     auth: true
  //   }
  // },
  // {
  //   path: "/vehicles",
  //   component: Vehicles,
  //   meta: {
  //     title: "Vehicles",
  //     layout: "admin",
  //     auth: true
  //   }
  // },
  {
    path: "/customer/create",
    component: CustomerCreate,
    meta: {
      title: "Customer Create",
      layout: "blank",
      // auth: true
    }
  },
  {
    path: "/success",
    component: Success,
    meta: {
      title: "Route Line",
      layout: "blank"
    }
  },
  {
    path: "*",
    component: Error404,
    meta: {
      title: "404 Error"
    }
  }
];

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    const position = savedPosition || {
      x: 0,
      y: 0
    };
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(position);
      }, 200);
    });
  }
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.meta && to.meta.auth) {
    if (!store.state.user) {
      localStorage.setItem("goBackTo", to.path);
      router.push("/");
      return;
    } else {
      // if ( store.state.isPlanExpired && to.meta.name !== "planView" ) {
      //   if ( from.meta.name !== "planView" ) {
      //     router.push(`/settings/subscription/${store.state.planId}?model=true`);
      //   }
      //   NProgress.done();
      //   return;
      // }

      store.dispatch("toggleSideDrawer", true);
    }
  }

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (nearestWithTitle)
    document.title =
      nearestWithTitle.meta.title +
      ((nearestWithTitle.meta.title.indexOf("Route Line") === -1 &&
        " · Route Line") ||
        "");
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  Array.from(document.querySelectorAll("[data-routerMetas]")).map(el =>
    el.parentNode.removeChild(el)
  );
  if (!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });
      tag.setAttribute("data-routerMetas", "");
      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));
  next();
});

router.afterEach(() => {
  setTimeout(() => {
    smartquotes();
  }, 301);
  NProgress.done();
});

export default router;
